import React from 'react'
import {
  Section,
  SectionHeader,
  SectionBody,
  Table,
  TableColumn,
  TableRecord,
} from '@apexinternal/ui-components'
import { BoxProps } from '@chakra-ui/layout'
import { isEmpty, startCase, lowerCase } from 'lodash'
import { Documents } from 'types'
import { formatDate, LONG_DATE_FORMAT } from '../../utils'

interface DocumentsTableProps extends BoxProps {
  documents?: Documents[]
}

const assembleColumn = (
  label: string,
  recordField: string,
  width: number,
  cellRenderer?: ({ value }: { value: any }) => JSX.Element
): TableColumn => ({
  key: recordField,
  label,
  recordField,
  width,
  isCentered: false,
  isSortable: true,
  ...cellRenderer,
})

const DocumentsTable = ({ documents, ...rest }: DocumentsTableProps) => {
  if (isEmpty(documents) || !documents) {
    return null
  }

  const columns: TableColumn[] = [
    assembleColumn('Document Name', 'documentName', 100),
    assembleColumn('Code', 'documentCode', 50),
    assembleColumn('Status', 'status', 75),
    assembleColumn('Req?', 'isRequired', 50),
    assembleColumn('Last Update', 'statusUpdatedDate', 75),
  ]

  const data: TableRecord[] = documents?.map(
    ({ documentName, documentCode, status, isRequired, statusUpdatedDate }) => {
      return {
        key: `${documentCode}_${statusUpdatedDate}`,
        documentName: startCase(lowerCase(documentName)) || '-',
        documentCode: documentCode || '-',
        status: startCase(lowerCase(status)) || '—',
        isRequired: isRequired ? 'Yes' : 'No',
        statusUpdatedDate: statusUpdatedDate
          ? formatDate(statusUpdatedDate, LONG_DATE_FORMAT)
          : '-',
      }
    }
  )

  return (
    <Section {...rest}>
      <SectionHeader>Documents</SectionHeader>
      <SectionBody>
        {data && !isEmpty(data) && (
          <Table
            columns={columns}
            data={data}
            defaultSort={{ field: 'documentCode', ascending: true }}
          />
        )}
      </SectionBody>
    </Section>
  )
}

export default DocumentsTable
